import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import get from 'lodash.get';
import classnames from 'classnames';

import { trackEvent } from 'dibs-tracking';

import { SeoButton } from 'dibs-seo/exports/SeoButton';
import { Carousel } from 'dibs-carousel';
import { ContemporaryLandingCategoriesTab } from './ContemporaryLandingCategoriesTab';
import { ContemporaryLandingCategoriesModuleItem } from './ContemporaryLandingCategoriesModuleItem';

import styles from './ContemporaryLandingCategoriesModule.scss';

class ContemporaryLandingCategoriesModuleComponent extends Component {
    constructor(props) {
        super(props);

        this.state = { tabIndex: 0 };
        this.setTabIndex = this.setTabIndex.bind(this);
        this.trackShopAllClick = this.trackShopAllClick.bind(this);
    }

    setTabIndex(tabIndex, tabName) {
        trackEvent({
            action: 'featured category',
            category: 'contemporary landing page interaction',
            label: `l2 nav clicked|${tabName}`,
        });
        this.setState({ tabIndex });
    }

    trackShopAllClick(categoryL2) {
        trackEvent({
            action: 'featured category',
            category: 'contemporary landing page interaction',
            label: `l2 shop all clicked|${categoryL2}`,
        });
    }

    render() {
        const { contemporaryLandingRow, showSwiper } = this.props;

        if (!contemporaryLandingRow || !contemporaryLandingRow.items) {
            return null;
        }

        const { tabIndex } = this.state;
        const title = get(contemporaryLandingRow, 'items[0].text');
        const categories = get(contemporaryLandingRow, 'items[1].items') || [];
        const categoryItems = categories.reduce((acc, category) => {
            acc = acc.concat(category.items);
            return acc;
        }, []);
        const navClasses = classnames(styles.nav, { [styles.swiper]: showSwiper });
        const navBarClasses = classnames('colXs4', styles.navBar, {
            [styles.firstTab]: tabIndex === 0,
            [styles.secondTab]: tabIndex === 1,
            [styles.thirdTab]: tabIndex === 2,
        });
        const carouselClasses = { item: styles.item };
        const categoryLinkData = get(categories[tabIndex], 'linkData');
        const categoryName = get(categories[tabIndex], 'name') || '';

        const tabIndexProduct = tabIndex * 4;
        return (
            <div className={styles.wrapper}>
                <div className={styles.title}>{title}</div>
                <div className={navClasses}>
                    <div className="rowFlex">
                        {categories.map((category, index) => (
                            <ContemporaryLandingCategoriesTab
                                key={`${category.name}-${index}`}
                                isSelected={this.state.tabIndex === index}
                                index={index}
                                setTabIndex={this.setTabIndex}
                                tab={category}
                            />
                        ))}
                        <div className={navBarClasses}>
                            <div className={styles.bar} />
                        </div>
                    </div>
                </div>
                <div className={`rowFlex ${styles.items}`}>
                    <Carousel
                        dataTn="category-items-carousel"
                        classNames={
                            showSwiper
                                ? { ...carouselClasses, list: styles.swiper }
                                : carouselClasses
                        }
                        slideCarouselItems
                        hideArrows
                        index={tabIndex * 4}
                        totalItems={4}
                        itemsPerPage={showSwiper ? 2.5 : 4}
                        renderItem={({ index }) => (
                            <ContemporaryLandingCategoriesModuleItem
                                item={categoryItems[index + tabIndexProduct]}
                            />
                        )}
                    />
                </div>
                <div className={styles.button}>
                    <SeoButton
                        linkData={categoryLinkData}
                        size="medium"
                        onClick={() => this.trackShopAllClick(categoryName)}
                    >
                        <FormattedMessage
                            id="contemporaryLanding.categoriesModule.shopAllCategory"
                            defaultMessage="Shop All {categoryName}"
                            values={{ categoryName }}
                        />
                    </SeoButton>
                </div>
            </div>
        );
    }
}

ContemporaryLandingCategoriesModuleComponent.defaultProps = {
    showSwiper: false,
};

ContemporaryLandingCategoriesModuleComponent.propTypes = {
    contemporaryLandingRow: PropTypes.object,
    showSwiper: PropTypes.bool.isRequired,
};

export const ContemporaryLandingCategoriesModule = createFragmentContainer(
    ContemporaryLandingCategoriesModuleComponent,
    {
        contemporaryLandingRow: graphql`
            fragment ContemporaryLandingCategoriesModule_contemporaryLandingRow on ContemporaryLandingRow {
                ... on ContemporaryLandingRow {
                    items {
                        ... on ContemporaryLandingHeader {
                            text
                            type
                        }
                        ... on ContemporaryLandingRow {
                            items {
                                ... on ContemporaryLandingCategoryL2 {
                                    linkData {
                                        ...SeoButton_linkData
                                    }
                                    items {
                                        linkData {
                                            ...SeoLink_linkData
                                        }
                                        key
                                        name
                                        ... on ContemporaryLandingCategoryL3 {
                                            linkData {
                                                ...SeoLink_linkData
                                            }
                                            imagePath
                                            name
                                        }
                                    }
                                    key
                                    name
                                }
                            }
                            type
                        }
                    }
                }
            }
        `,
    }
);
